module.exports = "/_next/static/images/image8-e03c368a8b609eaf6acb2380ea184a28.png";